import React from "react";
import "./InstituteDashboard.css";
import {
  FaUserGraduate,
  FaChalkboardTeacher,
  FaClipboardCheck,
  FaSchool,
  FaCalendarAlt,
  FaFileInvoice,
  FaBullhorn,
  FaChartLine,
  FaTable,
  FaFileAlt
} from "react-icons/fa";

const cards = [
  { title: "Attendance", icon: <FaClipboardCheck />, color: "#4CAF50" },
  { title: "Students", icon: <FaUserGraduate />, color: "#3F51B5" },
  { title: "Teachers", icon: <FaChalkboardTeacher />, color: "#9C27B0" },
  { title: "Classes / Batches", icon: <FaSchool />, color: "#FF9800" },
  { title: "Timetable", icon: <FaCalendarAlt />, color: "#00BCD4" },
  { title: "Fees Management", icon: <FaFileInvoice />, color: "#E91E63" },
  { title: "Exams", icon: <FaTable />, color: "#673AB7" },
  { title: "Results / Performance", icon: <FaChartLine />, color: "#2196F3" },
  { title: "Notices", icon: <FaBullhorn />, color: "#795548" },
  { title: "Reports", icon: <FaFileAlt />, color: "#607D8B" }
];

export default function InstituteDashboard() {
  return (
    <div className="institute-dashboard">
      <div className="dashboard-header">
        <h1>Institute Dashboard</h1>
        <p>Manage academics, attendance & administration</p>
      </div>

      <div className="dashboard-grid">
        {cards.map((card, index) => (
          <div className="dashboard-card" key={index}>
            <div
              className="card-icon"
              style={{ backgroundColor: card.color }}
            >
              {card.icon}
            </div>
            <h3>{card.title}</h3>
          </div>
        ))}
      </div>
    </div>
  );
}